export default __webpack_public_path__ + "static/Innovation-b3c6e2fcd6d0f56a5fd7182dab888900.webp";